export default __webpack_public_path__ + "static/media/IMG_1854 copie.526028b9.jpg";